import { render } from "./addedCart.vue?vue&type=template&id=8359dede"
import script from "./addedCart.vue?vue&type=script&lang=js"
export * from "./addedCart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__